import { CountryNameCodeType, RegionNameCodeType } from "@/types";
import ENV_VARIABLES from "@/env";

export const WORLD_BOUNDS = [[17.479306441311508, -10.54686794728837]];
export const MIN_MAP_ZOOM = 2;
export const MAX_MAP_ZOOM = 10;

export const REACT_APP_MAPBOX_TOKEN = ENV_VARIABLES.MAPBOX_PUBLIC_TOKEN;

// export const MAP_STYLE = "mapbox://styles/antbit/cmm53414t004z01qzgvm00nj3";
export const MAP_STYLE = "mapbox://styles/antbit/cmm566cn6009601qw5ltecmhn";
export const MAP_STYLE__DARK = "mapbox://styles/antbit/clpa6wpke004s01pj0m6xed01";

export const COUNTRY_MAP_STYLE = "mapbox://styles/antbit/cmm54dit200ao01r63ljrg31j";
export const COUNTRY_MAP_STYLE__DARK = "mapbox://styles/antbit/cluyks0jk004701qrfzf413s2";

export const MAP_SOURCE_COUNTRY_TILESET = "mapbox://antbit.93ij9gqb";
export const MAP_LAYER_TILESET_ID = "ne_10m_admin_0_countries-8rmsj4";

export const MAP_CONTAINER_STYLE = {
  height: "100%",
  width: "100%",
  backgroundColor: "white",
  borderRadius: "8px"
};

export const MAP_CONTAINER_STYLE__DARK = {
  height: "100%",
  width: "100%",
  backgroundColor: "black",
  borderRadius: "8px"
};

export const INITIAL_MAP_VIEW_STATE = {
  latitude: WORLD_BOUNDS[0][0],
  longitude: WORLD_BOUNDS[0][1],
  zoom: 1
};

export const REGION_BY_ISO2: Record<string, string> = {
  AD: "EMEA",
  AE: "EMEA",
  AF: "APAC",
  AG: "LATAM",
  AI: "EMEA",
  AL: "EMEA",
  AM: "EMEA",
  AO: "EMEA",
  AQ: "EMEA",
  AR: "LATAM",
  AS: "APAC",
  AT: "EMEA",
  AU: "APAC",
  AW: "EMEA",
  AX: "EMEA",
  AZ: "EMEA",
  BA: "EMEA",
  BB: "LATAM",
  BD: "APAC",
  BE: "EMEA",
  BF: "EMEA",
  BG: "EMEA",
  BH: "EMEA",
  BI: "EMEA",
  BJ: "EMEA",
  BL: "EMEA",
  BM: "EMEA",
  BN: "APAC",
  BO: "LATAM",
  BR: "LATAM",
  BS: "LATAM",
  BT: "APAC",
  BW: "EMEA",
  BY: "EMEA",
  BZ: "LATAM",
  CA: "Northern America",
  CD: "EMEA",
  CF: "EMEA",
  CG: "EMEA",
  CH: "EMEA",
  CI: "EMEA",
  CK: "APAC",
  CL: "LATAM",
  CM: "EMEA",
  CN: "APAC",
  CO: "LATAM",
  CR: "LATAM",
  CU: "LATAM",
  CV: "EMEA",
  CW: "EMEA",
  CY: "EMEA",
  CZ: "EMEA",
  DE: "EMEA",
  DJ: "EMEA",
  DK: "EMEA",
  DM: "LATAM",
  DO: "LATAM",
  DZ: "EMEA",
  EC: "LATAM",
  EE: "EMEA",
  EG: "EMEA",
  EH: "EMEA",
  ER: "EMEA",
  ES: "EMEA",
  ET: "EMEA",
  FI: "EMEA",
  FJ: "APAC",
  FK: "EMEA",
  FM: "APAC",
  FO: "EMEA",
  FR: "EMEA",
  GA: "EMEA",
  GB: "EMEA",
  GD: "LATAM",
  GE: "EMEA",
  GG: "EMEA",
  GH: "EMEA",
  GI: "EMEA",
  GL: "EMEA",
  GM: "EMEA",
  GN: "EMEA",
  GQ: "EMEA",
  GR: "EMEA",
  GS: "EMEA",
  GT: "LATAM",
  GU: "APAC",
  GW: "EMEA",
  GY: "LATAM",
  HK: "APAC",
  HM: "APAC",
  HN: "LATAM",
  HR: "EMEA",
  HT: "LATAM",
  HU: "EMEA",
  ID: "APAC",
  IE: "EMEA",
  IL: "EMEA",
  IM: "EMEA",
  IN: "APAC",
  IO: "APAC",
  IQ: "EMEA",
  IR: "EMEA",
  IS: "EMEA",
  IT: "EMEA",
  JE: "EMEA",
  JM: "LATAM",
  JO: "EMEA",
  JP: "APAC",
  KE: "EMEA",
  KG: "EMEA",
  KH: "APAC",
  KI: "APAC",
  KM: "EMEA",
  KN: "LATAM",
  KP: "APAC",
  KR: "APAC",
  KW: "EMEA",
  KY: "EMEA",
  KZ: "EMEA",
  LA: "APAC",
  LB: "EMEA",
  LC: "LATAM",
  LI: "EMEA",
  LK: "APAC",
  LR: "EMEA",
  LS: "EMEA",
  LT: "EMEA",
  LU: "EMEA",
  LV: "EMEA",
  LY: "EMEA",
  MA: "EMEA",
  MC: "EMEA",
  MD: "EMEA",
  ME: "EMEA",
  MF: "EMEA",
  MG: "EMEA",
  MH: "APAC",
  MK: "EMEA",
  ML: "EMEA",
  MM: "APAC",
  MN: "APAC",
  MO: "APAC",
  MP: "APAC",
  MR: "EMEA",
  MS: "EMEA",
  MT: "EMEA",
  MU: "EMEA",
  MV: "APAC",
  MW: "EMEA",
  MX: "LATAM",
  MY: "APAC",
  MZ: "EMEA",
  NA: "EMEA",
  NC: "APAC",
  NE: "EMEA",
  NF: "APAC",
  NG: "EMEA",
  NI: "LATAM",
  NL: "EMEA",
  NO: "EMEA",
  NP: "APAC",
  NR: "APAC",
  NU: "APAC",
  NZ: "APAC",
  OM: "EMEA",
  PA: "LATAM",
  PE: "LATAM",
  PF: "APAC",
  PG: "APAC",
  PH: "APAC",
  PK: "APAC",
  PL: "EMEA",
  PM: "EMEA",
  PN: "APAC",
  PR: "LATAM",
  PS: "EMEA",
  PT: "EMEA",
  PW: "APAC",
  PY: "LATAM",
  QA: "EMEA",
  RO: "EMEA",
  RS: "EMEA",
  RU: "EMEA",
  RW: "EMEA",
  SA: "EMEA",
  SB: "APAC",
  SC: "EMEA",
  SD: "EMEA",
  SE: "EMEA",
  SG: "APAC",
  SH: "EMEA",
  SI: "EMEA",
  SK: "EMEA",
  SL: "EMEA",
  SM: "EMEA",
  SN: "EMEA",
  SO: "EMEA",
  SR: "LATAM",
  SS: "EMEA",
  ST: "EMEA",
  SV: "LATAM",
  SX: "EMEA",
  SY: "EMEA",
  SZ: "EMEA",
  TC: "EMEA",
  TD: "EMEA",
  TF: "EMEA",
  TG: "EMEA",
  TH: "APAC",
  TJ: "EMEA",
  TL: "APAC",
  TM: "EMEA",
  TN: "EMEA",
  TO: "APAC",
  TR: "EMEA",
  TT: "LATAM",
  TV: "APAC",
  TW: "APAC",
  TZ: "EMEA",
  UA: "EMEA",
  UG: "EMEA",
  UM: "APAC",
  US: "Northern America",
  UY: "LATAM",
  UZ: "EMEA",
  VA: "EMEA",
  VC: "LATAM",
  VE: "LATAM",
  VG: "EMEA",
  VI: "LATAM",
  VN: "APAC",
  VU: "APAC",
  WF: "APAC",
  WS: "APAC",
  XK: "EMEA",
  YE: "EMEA",
  ZA: "EMEA",
  ZM: "EMEA",
  ZW: "EMEA"
};

export const COUNTRIES = [
  {
    countryName: "Indonesia",
    countryCode: "ID"
  },
  {
    countryName: "Malaysia",
    countryCode: "MY"
  },
  {
    countryName: "Chile",
    countryCode: "CL"
  },
  {
    countryName: "Bolivia",
    countryCode: "BO"
  },
  {
    countryName: "Peru",
    countryCode: "PE"
  },
  {
    countryName: "Argentina",
    countryCode: "AR"
  },
  {
    countryName: "Cyprus",
    countryCode: "CY"
  },
  {
    countryName: "India",
    countryCode: "IN"
  },
  {
    countryName: "China",
    countryCode: "CN"
  },
  {
    countryName: "Israel",
    countryCode: "IL"
  },
  {
    countryName: "Palestine",
    countryCode: "PS"
  },
  {
    countryName: "Lebanon",
    countryCode: "LB"
  },
  {
    countryName: "Ethiopia",
    countryCode: "ET"
  },
  {
    countryName: "S. Sudan",
    countryCode: "SS"
  },
  {
    countryName: "Somalia",
    countryCode: "SO"
  },
  {
    countryName: "Kenya",
    countryCode: "KE"
  },
  {
    countryName: "Malawi",
    countryCode: "MW"
  },
  {
    countryName: "Tanzania",
    countryCode: "TZ"
  },
  {
    countryName: "Syria",
    countryCode: "SY"
  },
  {
    countryName: "France",
    countryCode: "FR"
  },
  {
    countryName: "Suriname",
    countryCode: "SR"
  },
  {
    countryName: "Guyana",
    countryCode: "GY"
  },
  {
    countryName: "South Korea",
    countryCode: "KR"
  },
  {
    countryName: "North Korea",
    countryCode: "KP"
  },
  {
    countryName: "Morocco",
    countryCode: "MA"
  },
  {
    countryName: "W. Sahara",
    countryCode: "EH"
  },
  {
    countryName: "Costa Rica",
    countryCode: "CR"
  },
  {
    countryName: "Nicaragua",
    countryCode: "NI"
  },
  {
    countryName: "Congo",
    countryCode: "CG"
  },
  {
    countryName: "Dem. Rep. Congo",
    countryCode: "CD"
  },
  {
    countryName: "Bhutan",
    countryCode: "BT"
  },
  {
    countryName: "Ukraine",
    countryCode: "UA"
  },
  {
    countryName: "Belarus",
    countryCode: "BY"
  },
  {
    countryName: "Namibia",
    countryCode: "NA"
  },
  {
    countryName: "South Africa",
    countryCode: "ZA"
  },
  {
    countryName: "St-Martin",
    countryCode: "MF"
  },
  {
    countryName: "Sint Maarten",
    countryCode: "SX"
  },
  {
    countryName: "Oman",
    countryCode: "OM"
  },
  {
    countryName: "Uzbekistan",
    countryCode: "UZ"
  },
  {
    countryName: "Kazakhstan",
    countryCode: "KZ"
  },
  {
    countryName: "Tajikistan",
    countryCode: "TJ"
  },
  {
    countryName: "Lithuania",
    countryCode: "LT"
  },
  {
    countryName: "Brazil",
    countryCode: "BR"
  },
  {
    countryName: "Uruguay",
    countryCode: "UY"
  },
  {
    countryName: "Mongolia",
    countryCode: "MN"
  },
  {
    countryName: "Russia",
    countryCode: "RU"
  },
  {
    countryName: "Czechia",
    countryCode: "CZ"
  },
  {
    countryName: "Germany",
    countryCode: "DE"
  },
  {
    countryName: "Estonia",
    countryCode: "EE"
  },
  {
    countryName: "Latvia",
    countryCode: "LV"
  },
  {
    countryName: "Norway",
    countryCode: "NO"
  },
  {
    countryName: "Sweden",
    countryCode: "SE"
  },
  {
    countryName: "Finland",
    countryCode: "FI"
  },
  {
    countryName: "Vietnam",
    countryCode: "VN"
  },
  {
    countryName: "Cambodia",
    countryCode: "KH"
  },
  {
    countryName: "Luxembourg",
    countryCode: "LU"
  },
  {
    countryName: "United Arab Emirates",
    countryCode: "AE"
  },
  {
    countryName: "Belgium",
    countryCode: "BE"
  },
  {
    countryName: "Georgia",
    countryCode: "GE"
  },
  {
    countryName: "North Macedonia",
    countryCode: "MK"
  },
  {
    countryName: "Albania",
    countryCode: "AL"
  },
  {
    countryName: "Azerbaijan",
    countryCode: "AZ"
  },
  {
    countryName: "Kosovo",
    countryCode: "XK"
  },
  {
    countryName: "Turkey",
    countryCode: "TR"
  },
  {
    countryName: "Spain",
    countryCode: "ES"
  },
  {
    countryName: "Laos",
    countryCode: "LA"
  },
  {
    countryName: "Kyrgyzstan",
    countryCode: "KG"
  },
  {
    countryName: "Armenia",
    countryCode: "AM"
  },
  {
    countryName: "Denmark",
    countryCode: "DK"
  },
  {
    countryName: "Libya",
    countryCode: "LY"
  },
  {
    countryName: "Tunisia",
    countryCode: "TN"
  },
  {
    countryName: "Romania",
    countryCode: "RO"
  },
  {
    countryName: "Hungary",
    countryCode: "HU"
  },
  {
    countryName: "Slovakia",
    countryCode: "SK"
  },
  {
    countryName: "Poland",
    countryCode: "PL"
  },
  {
    countryName: "Ireland",
    countryCode: "IE"
  },
  {
    countryName: "United Kingdom",
    countryCode: "GB"
  },
  {
    countryName: "Greece",
    countryCode: "GR"
  },
  {
    countryName: "Zambia",
    countryCode: "ZM"
  },
  {
    countryName: "Sierra Leone",
    countryCode: "SL"
  },
  {
    countryName: "Guinea",
    countryCode: "GN"
  },
  {
    countryName: "Liberia",
    countryCode: "LR"
  },
  {
    countryName: "Central African Rep.",
    countryCode: "CF"
  },
  {
    countryName: "Sudan",
    countryCode: "SD"
  },
  {
    countryName: "Djibouti",
    countryCode: "DJ"
  },
  {
    countryName: "Eritrea",
    countryCode: "ER"
  },
  {
    countryName: "Austria",
    countryCode: "AT"
  },
  {
    countryName: "Iraq",
    countryCode: "IQ"
  },
  {
    countryName: "Italy",
    countryCode: "IT"
  },
  {
    countryName: "Switzerland",
    countryCode: "CH"
  },
  {
    countryName: "Iran",
    countryCode: "IR"
  },
  {
    countryName: "Netherlands",
    countryCode: "NL"
  },
  {
    countryName: "Liechtenstein",
    countryCode: "LI"
  },
  {
    countryName: "Côte d'Ivoire",
    countryCode: "CI"
  },
  {
    countryName: "Serbia",
    countryCode: "RS"
  },
  {
    countryName: "Mali",
    countryCode: "ML"
  },
  {
    countryName: "Senegal",
    countryCode: "SN"
  },
  {
    countryName: "Nigeria",
    countryCode: "NG"
  },
  {
    countryName: "Benin",
    countryCode: "BJ"
  },
  {
    countryName: "Angola",
    countryCode: "AO"
  },
  {
    countryName: "Croatia",
    countryCode: "HR"
  },
  {
    countryName: "Slovenia",
    countryCode: "SI"
  },
  {
    countryName: "Qatar",
    countryCode: "QA"
  },
  {
    countryName: "Saudi Arabia",
    countryCode: "SA"
  },
  {
    countryName: "Botswana",
    countryCode: "BW"
  },
  {
    countryName: "Zimbabwe",
    countryCode: "ZW"
  },
  {
    countryName: "Pakistan",
    countryCode: "PK"
  },
  {
    countryName: "Bulgaria",
    countryCode: "BG"
  },
  {
    countryName: "Thailand",
    countryCode: "TH"
  },
  {
    countryName: "San Marino",
    countryCode: "SM"
  },
  {
    countryName: "Haiti",
    countryCode: "HT"
  },
  {
    countryName: "Dominican Rep.",
    countryCode: "DO"
  },
  {
    countryName: "Chad",
    countryCode: "TD"
  },
  {
    countryName: "Kuwait",
    countryCode: "KW"
  },
  {
    countryName: "El Salvador",
    countryCode: "SV"
  },
  {
    countryName: "Guatemala",
    countryCode: "GT"
  },
  {
    countryName: "Timor-Leste",
    countryCode: "TL"
  },
  {
    countryName: "Brunei",
    countryCode: "BN"
  },
  {
    countryName: "Monaco",
    countryCode: "MC"
  },
  {
    countryName: "Algeria",
    countryCode: "DZ"
  },
  {
    countryName: "Mozambique",
    countryCode: "MZ"
  },
  {
    countryName: "eSwatini",
    countryCode: "SZ"
  },
  {
    countryName: "Burundi",
    countryCode: "BI"
  },
  {
    countryName: "Rwanda",
    countryCode: "RW"
  },
  {
    countryName: "Myanmar",
    countryCode: "MM"
  },
  {
    countryName: "Bangladesh",
    countryCode: "BD"
  },
  {
    countryName: "Andorra",
    countryCode: "AD"
  },
  {
    countryName: "Afghanistan",
    countryCode: "AF"
  },
  {
    countryName: "Montenegro",
    countryCode: "ME"
  },
  {
    countryName: "Bosnia and Herz.",
    countryCode: "BA"
  },
  {
    countryName: "Uganda",
    countryCode: "UG"
  },
  {
    countryName: "Cuba",
    countryCode: "CU"
  },
  {
    countryName: "Honduras",
    countryCode: "HN"
  },
  {
    countryName: "Ecuador",
    countryCode: "EC"
  },
  {
    countryName: "Colombia",
    countryCode: "CO"
  },
  {
    countryName: "Paraguay",
    countryCode: "PY"
  },
  {
    countryName: "Portugal",
    countryCode: "PT"
  },
  {
    countryName: "Moldova",
    countryCode: "MD"
  },
  {
    countryName: "Turkmenistan",
    countryCode: "TM"
  },
  {
    countryName: "Jordan",
    countryCode: "JO"
  },
  {
    countryName: "Nepal",
    countryCode: "NP"
  },
  {
    countryName: "Lesotho",
    countryCode: "LS"
  },
  {
    countryName: "Cameroon",
    countryCode: "CM"
  },
  {
    countryName: "Gabon",
    countryCode: "GA"
  },
  {
    countryName: "Niger",
    countryCode: "NE"
  },
  {
    countryName: "Burkina Faso",
    countryCode: "BF"
  },
  {
    countryName: "Togo",
    countryCode: "TG"
  },
  {
    countryName: "Ghana",
    countryCode: "GH"
  },
  {
    countryName: "Guinea-Bissau",
    countryCode: "GW"
  },
  {
    countryName: "Gibraltar",
    countryCode: "GI"
  },
  {
    countryName: "United States",
    countryCode: "US"
  },
  {
    countryName: "Canada",
    countryCode: "CA"
  },
  {
    countryName: "Mexico",
    countryCode: "MX"
  },
  {
    countryName: "Belize",
    countryCode: "BZ"
  },
  {
    countryName: "Panama",
    countryCode: "PA"
  },
  {
    countryName: "Venezuela",
    countryCode: "VE"
  },
  {
    countryName: "Papua New Guinea",
    countryCode: "PG"
  },
  {
    countryName: "Egypt",
    countryCode: "EG"
  },
  {
    countryName: "Yemen",
    countryCode: "YE"
  },
  {
    countryName: "Mauritania",
    countryCode: "MR"
  },
  {
    countryName: "Eq. Guinea",
    countryCode: "GQ"
  },
  {
    countryName: "Gambia",
    countryCode: "GM"
  },
  {
    countryName: "Hong Kong",
    countryCode: "HK"
  },
  {
    countryName: "Vatican",
    countryCode: "VA"
  },
  {
    countryName: "Antarctica",
    countryCode: "AQ"
  },
  {
    countryName: "Australia",
    countryCode: "AU"
  },
  {
    countryName: "Greenland",
    countryCode: "GL"
  },
  {
    countryName: "Fiji",
    countryCode: "FJ"
  },
  {
    countryName: "New Zealand",
    countryCode: "NZ"
  },
  {
    countryName: "New Caledonia",
    countryCode: "NC"
  },
  {
    countryName: "Madagascar",
    countryCode: "MG"
  },
  {
    countryName: "Philippines",
    countryCode: "PH"
  },
  {
    countryName: "Sri Lanka",
    countryCode: "LK"
  },
  {
    countryName: "Curaçao",
    countryCode: "CW"
  },
  {
    countryName: "Aruba",
    countryCode: "AW"
  },
  {
    countryName: "Bahamas",
    countryCode: "BS"
  },
  {
    countryName: "Turks and Caicos Is.",
    countryCode: "TC"
  },
  {
    countryName: "Taiwan",
    countryCode: "TW"
  },
  {
    countryName: "Japan",
    countryCode: "JP"
  },
  {
    countryName: "St. Pierre and Miquelon",
    countryCode: "PM"
  },
  {
    countryName: "Iceland",
    countryCode: "IS"
  },
  {
    countryName: "Pitcairn Is.",
    countryCode: "PN"
  },
  {
    countryName: "Fr. Polynesia",
    countryCode: "PF"
  },
  {
    countryName: "Fr. S. Antarctic Lands",
    countryCode: "TF"
  },
  {
    countryName: "Seychelles",
    countryCode: "SC"
  },
  {
    countryName: "Kiribati",
    countryCode: "KI"
  },
  {
    countryName: "Marshall Is.",
    countryCode: "MH"
  },
  {
    countryName: "Trinidad and Tobago",
    countryCode: "TT"
  },
  {
    countryName: "Grenada",
    countryCode: "GD"
  },
  {
    countryName: "St. Vin. and Gren.",
    countryCode: "VC"
  },
  {
    countryName: "Barbados",
    countryCode: "BB"
  },
  {
    countryName: "Saint Lucia",
    countryCode: "LC"
  },
  {
    countryName: "Dominica",
    countryCode: "DM"
  },
  {
    countryName: "U.S. Minor Outlying Is.",
    countryCode: "UM"
  },
  {
    countryName: "Montserrat",
    countryCode: "MS"
  },
  {
    countryName: "Antigua and Barb.",
    countryCode: "AG"
  },
  {
    countryName: "St. Kitts and Nevis",
    countryCode: "KN"
  },
  {
    countryName: "U.S. Virgin Is.",
    countryCode: "VI"
  },
  {
    countryName: "St-Barthélemy",
    countryCode: "BL"
  },
  {
    countryName: "Puerto Rico",
    countryCode: "PR"
  },
  {
    countryName: "Anguilla",
    countryCode: "AI"
  },
  {
    countryName: "British Virgin Is.",
    countryCode: "VG"
  },
  {
    countryName: "Jamaica",
    countryCode: "JM"
  },
  {
    countryName: "Cayman Is.",
    countryCode: "KY"
  },
  {
    countryName: "Bermuda",
    countryCode: "BM"
  },
  {
    countryName: "Heard I. and McDonald Is.",
    countryCode: "HM"
  },
  {
    countryName: "Saint Helena",
    countryCode: "SH"
  },
  {
    countryName: "Mauritius",
    countryCode: "MU"
  },
  {
    countryName: "Comoros",
    countryCode: "KM"
  },
  {
    countryName: "São Tomé and Principe",
    countryCode: "ST"
  },
  {
    countryName: "Cabo Verde",
    countryCode: "CV"
  },
  {
    countryName: "Malta",
    countryCode: "MT"
  },
  {
    countryName: "Jersey",
    countryCode: "JE"
  },
  {
    countryName: "Guernsey",
    countryCode: "GG"
  },
  {
    countryName: "Isle of Man",
    countryCode: "IM"
  },
  {
    countryName: "Åland",
    countryCode: "AX"
  },
  {
    countryName: "Faeroe Is.",
    countryCode: "FO"
  },
  {
    countryName: "Br. Indian Ocean Ter.",
    countryCode: "IO"
  },
  {
    countryName: "Singapore",
    countryCode: "SG"
  },
  {
    countryName: "Norfolk Island",
    countryCode: "NF"
  },
  {
    countryName: "Cook Is.",
    countryCode: "CK"
  },
  {
    countryName: "Tonga",
    countryCode: "TO"
  },
  {
    countryName: "Wallis and Futuna Is.",
    countryCode: "WF"
  },
  {
    countryName: "Samoa",
    countryCode: "WS"
  },
  {
    countryName: "Solomon Is.",
    countryCode: "SB"
  },
  {
    countryName: "Tuvalu",
    countryCode: "TV"
  },
  {
    countryName: "Maldives",
    countryCode: "MV"
  },
  {
    countryName: "Nauru",
    countryCode: "NR"
  },
  {
    countryName: "Micronesia",
    countryCode: "FM"
  },
  {
    countryName: "S. Geo. and the Is.",
    countryCode: "GS"
  },
  {
    countryName: "Falkland Is.",
    countryCode: "FK"
  },
  {
    countryName: "Vanuatu",
    countryCode: "VU"
  },
  {
    countryName: "Niue",
    countryCode: "NU"
  },
  {
    countryName: "American Samoa",
    countryCode: "AS"
  },
  {
    countryName: "Palau",
    countryCode: "PW"
  },
  {
    countryName: "Guam",
    countryCode: "GU"
  },
  {
    countryName: "N. Mariana Is.",
    countryCode: "MP"
  },
  {
    countryName: "Bahrain",
    countryCode: "BH"
  },
  {
    countryName: "Macao",
    countryCode: "MO"
  }
] as CountryNameCodeType[];

export const REGION_OPTIONS: RegionNameCodeType[] = [
  {
    regionName: "North America",
    regionCode: "north-america",
    countries: [
      { countryCode: "US", countryName: "United States" },
      { countryCode: "CA", countryName: "Canada" }
    ]
  },
  {
    regionName: "Western Europe",
    regionCode: "western-europe",
    countries: [
      { countryCode: "GB", countryName: "United Kingdom" },
      { countryCode: "DE", countryName: "Germany" },
      { countryCode: "FR", countryName: "France" },
      { countryCode: "ES", countryName: "Spain" },
      { countryCode: "IT", countryName: "Italy" },
      { countryCode: "NL", countryName: "Netherlands" },
      { countryCode: "BE", countryName: "Belgium" },
      { countryCode: "CH", countryName: "Switzerland" }
    ]
  },
  {
    regionName: "Greater China",
    regionCode: "greater-china",
    countries: [
      { countryCode: "CN", countryName: "China" },
      { countryCode: "HK", countryName: "Hong Kong" },
      { countryCode: "TW", countryName: "Taiwan" }
    ]
  },
  {
    regionName: "Southeast Asia",
    regionCode: "southeast-asia",
    countries: [
      { countryCode: "SG", countryName: "Singapore" },
      { countryCode: "MY", countryName: "Malaysia" },
      { countryCode: "ID", countryName: "Indonesia" },
      { countryCode: "PH", countryName: "Philippines" },
      { countryCode: "TH", countryName: "Thailand" },
      { countryCode: "VN", countryName: "Vietnam" }
    ]
  },
  {
    regionName: "ANZ",
    regionCode: "anz",
    countries: [
      { countryCode: "AU", countryName: "Australia" },
      { countryCode: "NZ", countryName: "New Zealand" }
    ]
  }
];

export const DEFAULT_REGION = {
  regionName: "Worldwide",
  regionCode: "global",
  countries: []
} as RegionNameCodeType;
